export default __webpack_public_path__ + "static/media/alert_ticket.75e73623.svg";